<template>
  <div>
    <h2 class="page-title">大课记录</h2>
    <el-card>
      <div class="toolbar">
        <el-input
          v-model="keyword"
          clearable
          placeholder="学员姓名 / 电话"
          style="width:220px;margin-right:8px"
          @keyup.enter.native="search"
        />
        <el-button type="primary" size="small" @click="search">搜索</el-button>
      </div>
      <div class="table-wrapper">
        <el-table :data="list" v-loading="loading" border stripe>
          <el-table-column prop="studentName" label="学生" width="110" />
          <el-table-column prop="hoursDeducted" label="扣除课时" width="90" />
          <el-table-column prop="checkInType" label="签到方式" width="90">
            <template slot-scope="{ row }">{{ row.checkInType === 1 ? '刷脸' : (row.checkInType === 6 ? '抵小课' : (row.checkInType === 7 ? '调账' : (row.checkInType === 4 ? '接龙' : (row.checkInType === 5 ? '退课' : '手动')))) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="{ row }">
              <el-tag v-if="row.recordStatus === 2" type="warning" size="mini">欠费待缴</el-tag>
              <el-tag v-else-if="row.recordStatus === 3" type="success" size="mini">已补缴</el-tag>
              <el-tag v-else type="info" size="mini">正常</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="similarityScore" label="匹配度" width="90">
            <template slot-scope="{ row }">{{ formatScore(row.similarityScore) }}</template>
          </el-table-column>
          <el-table-column prop="checkInTime" label="签到时间" min-width="160" />
          <el-table-column prop="remark" label="备注" min-width="120" />
        </el-table>
        <el-pagination
          style="margin-top: 16px; text-align: right"
          @current-change="handlePageChange"
          :current-page="page"
          :page-size="size"
          :total="total"
          layout="total, prev, pager, next"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCheckInRecords } from '../api'

export default {
  name: 'CheckInRecords',
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      size: 20,
      total: 0,
      keyword: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    formatScore(score) {
      if (score == null || score === '') return '-'
      const n = Number(score)
      if (isNaN(n)) return score
      return (n <= 1 ? (n * 100).toFixed(1) : n.toFixed(1)) + '%'
    },
    search() {
      this.page = 1
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const params = { page: this.page, size: this.size }
        if (this.keyword) params.keyword = this.keyword.trim()
        const res = await getCheckInRecords(params)
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      } finally {
        this.loading = false
      }
    },
    handlePageChange(p) {
      this.page = p
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 20px; }
.toolbar { margin-bottom: 16px; }
.table-wrapper { overflow-x: auto; }
</style>
